// @ai-generated 2026-09-04T08:07:37+00:00 by dimitri.driediger@synqony.com using Claude Opus 5
import { type ApiRequisition } from '@Model';
import { defineWizardStep, type WizardStep, type WizardStepErrors } from '@synqo/frontend-component-library';
import { type RequisitionAction } from '@utils/requisitionAction';
import { type RequisitionWizardState } from '../../RequisitionWizardState';
import { ActionStepBody, type ActionStepErrorKey } from './ActionStepBody';

interface DefineActionStepProps {
    data: ApiRequisition;
    stockTotal: number;
    /** How many containers open orders plan to place at the site. */
    plannedTotal: number;
    isStockLoading: boolean;
    action: RequisitionAction | undefined;
    /** What switching the action would throw away, whichever of the two kinds the order is. */
    discardableCount: number;
    onChoose: (action: RequisitionAction) => void;
    i18n: (key: string) => string;
}

/**
 * The step that asks what should happen. Its own "next" is the tile click, so the validation only
 * catches the customer who reaches the footer without having chosen anything.
 */
export function defineActionStep({
    data,
    stockTotal,
    plannedTotal,
    isStockLoading,
    action,
    discardableCount,
    onChoose,
    i18n,
}: DefineActionStepProps): WizardStep<RequisitionWizardState> {
    return defineWizardStep<RequisitionWizardState, ActionStepErrorKey>({
        key: 'action',
        label: i18n('Was möchtest du tun?'),
        render: () => (
            <ActionStepBody
                site={data.site}
                stockTotal={stockTotal}
                plannedTotal={plannedTotal}
                isStockLoading={isStockLoading}
                action={action}
                discardableCount={discardableCount}
                onChoose={onChoose}
            />
        ),
        validate: () => {
            const errors: WizardStepErrors<ActionStepErrorKey> = {};
            if (action === undefined) {
                errors.action = i18n('Bitte wähle aus, was passieren soll.');
            }
            return errors;
        },
    });
}
